import { formatPrice } from "../../../utils/formatPrice";

export function ComponentSoma({ data }) {
  const soma = data.reduce((acc, item) => {
    if (item.credito_utilizado !== "S") {
      return acc + parseFloat(item.credito_disponivel);
    }

    return acc;
  }, 0);

  const formattedPrice = isNaN(soma) ? "0,00" : formatPrice(soma);

  return <>{formattedPrice}</>;
}
